import { useCallback, useEffect, useRef, useState } from 'react'

export const usePreviewNavigation = (listLength: number) => {
  const [activePreviewIndex, setActivePreviewIndex] = useState<number | null>(
    null
  )
  const isNavigatingRef = useRef(false)

  const handleOpenPreview = useCallback((index: number) => {
    isNavigatingRef.current = false
    setActivePreviewIndex(index)
  }, [])

  const handleClosePreview = useCallback(() => {
    isNavigatingRef.current = false
    setActivePreviewIndex(null)
  }, [])

  const handleNextPreview = useCallback(() => {
    isNavigatingRef.current = true
    setActivePreviewIndex(prev =>
      prev !== null ? Math.min(prev + 1, listLength - 1) : null
    )
  }, [listLength])

  const handlePrevPreview = useCallback(() => {
    isNavigatingRef.current = true
    setActivePreviewIndex(prev =>
      prev !== null ? Math.max(prev - 1, 0) : null
    )
  }, [])

  useEffect(() => {
    if (activePreviewIndex === null) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault()
        handlePrevPreview()
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        handleNextPreview()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [activePreviewIndex, handleNextPreview, handlePrevPreview])

  return {
    activePreviewIndex,
    isNavigating: isNavigatingRef,
    handleOpenPreview,
    handleClosePreview,
    handleNextPreview,
    handlePrevPreview
  }
}
